import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useRef, useState, KeyboardEvent } from 'react';
import TextField from '@classify/react-core-components/TextField';
import Typography from '@classify/react-core-components/Typography';
import IconButton from '@classify/react-core-components/IconButton';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import SmartInputWrapper, { SmartInputWrapperActions } from '../../SmartInputWrapper';
export interface MessageInputProps {
  placeholder: string;
  autoFocus?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  onSend: (value: string) => void;
  isSendDisabled?: boolean;
  translations?: {
    warningMessage: string;
  };
}
const MessageInput = t0 => {
  const $ = _c(38);
  const {
    placeholder,
    autoFocus,
    value: t1,
    onChange,
    onSend,
    isSendDisabled: t2,
    translations
  } = t0;
  const value = t1 === undefined ? "" : t1;
  const isSendDisabled = t2 === undefined ? false : t2;
  const [inputValue, setInputValue] = useState(value);
  const inputRef = useRef(null);
  const previousValueRef = useRef(value);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      inputRef.current?.focus();
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const refocusInput = t3;
  let t4;
  let t5;
  if ($[1] !== value) {
    t4 = () => {
      setInputValue(value);
    };
    t5 = [value];
    $[1] = value;
    $[2] = t4;
    $[3] = t5;
  } else {
    t4 = $[2];
    t5 = $[3];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[4] !== value) {
    t6 = () => {
      if (previousValueRef.current !== "" && value === "") {
        refocusInput();
      }
      previousValueRef.current = value;
    };
    t7 = [value];
    $[4] = value;
    $[5] = t6;
    $[6] = t7;
  } else {
    t6 = $[5];
    t7 = $[6];
  }
  useLayoutEffect(t6, t7);
  let t8;
  if ($[7] !== inputValue || $[8] !== isSendDisabled || $[9] !== onSend) {
    t8 = event => {
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault();
        if (!isSendDisabled) {
          onSend(inputValue);
          refocusInput();
        }
      }
    };
    $[7] = inputValue;
    $[8] = isSendDisabled;
    $[9] = onSend;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleKeyDown = t8;
  let t9;
  if ($[11] !== inputValue || $[12] !== isSendDisabled || $[13] !== onSend) {
    t9 = event_0 => {
      event_0.preventDefault();
      if (isSendDisabled) {
        return;
      }
      onSend(inputValue);
      refocusInput();
    };
    $[11] = inputValue;
    $[12] = isSendDisabled;
    $[13] = onSend;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== onChange) {
    t10 = event_1 => {
      const newValue = event_1.target.value;
      setInputValue(newValue);
      onChange?.(newValue);
    };
    $[15] = onChange;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      enterKeyHint: "send"
    };
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      flexGrow: 1,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent !important"
      },
      "& textarea": {
        overflowY: "auto"
      }
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== autoFocus || $[20] !== handleKeyDown || $[21] !== inputValue || $[22] !== placeholder || $[23] !== t10) {
    t13 = <TextField name="message-input" autoComplete="off" inputRef={inputRef} placeholder={placeholder} autoFocus={autoFocus} multiline={true} minRows={2} maxRows={3} value={inputValue} onKeyDown={handleKeyDown} onChange={t10} inputProps={t11} sx={t12} />;
    $[19] = autoFocus;
    $[20] = handleKeyDown;
    $[21] = inputValue;
    $[22] = placeholder;
    $[23] = t10;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SendSharpIcon />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== isSendDisabled) {
    t15 = <SmartInputWrapperActions variant="discrete"><IconButton type="submit" title="Send" tooltip="Send" aria-label="Send" disabled={isSendDisabled} color="primary">{t14}</IconButton></SmartInputWrapperActions>;
    $[26] = isSendDisabled;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== isSendDisabled || $[29] !== t13 || $[30] !== t15) {
    t16 = <SmartInputWrapper isLoading={isSendDisabled}>{t13}{t15}</SmartInputWrapper>;
    $[28] = isSendDisabled;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== translations?.warningMessage) {
    t17 = translations?.warningMessage && <Typography variant="bodySmall" component="div" sx={{
      mt: 1
    }}>{translations?.warningMessage}</Typography>;
    $[32] = translations?.warningMessage;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t16 || $[35] !== t17 || $[36] !== t9) {
    t18 = <form autoComplete="off" onSubmit={t9}>{t16}{t17}</form>;
    $[34] = t16;
    $[35] = t17;
    $[36] = t9;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
};
export default MessageInput;